import React, { memo } from "react";
import { Select, FormControl, FormLabel, FormErrorMessage, FormHelperText } from "@chakra-ui/react";
import { FastField, Field } from "formik";

function SelectField({ name, label, options, helperText, isOptional = false, ...rest }) {
  return (
    <FastField name={name}>
      {({ field, meta }) => {
        const isInvalid = meta.touched && meta.error;
        return (
          <FormControl isInvalid={isInvalid} isRequired={!isOptional}>
            {label && (
              <FormLabel htmlFor={name} requiredIndicator={false}>
                {label}
              </FormLabel>
            )}
            <Select
              {...field}
              {...rest}
              id={name}
              data-testid={`select-${name}`}
              onChange={(e) => {
                rest && rest.onChange && rest.onChange(e);
                field && field.onChange && field.onChange(e);
              }}
            >
              {options.map(({ label, value }) => (
                <option value={value} key={`${name}-option-${value}`}>
                  {label}
                </option>
              ))}
            </Select>
            {!isInvalid && !!helperText ? (
              <FormHelperText>{helperText}</FormHelperText>
            ) : (
              <FormErrorMessage>{meta.error}</FormErrorMessage>
            )}
          </FormControl>
        );
      }}
    </FastField>
  );
}

/**
 *
 * @description Exactly the same as <SelectField /> but using the standard Formik <Field /> component
 * rather than the optimized <FastField /> to avoid ensure render on state change. See: https://formik.org/docs/api/fastfield
 */
export function SelectFieldStandard({
  name,
  label,
  options,
  helperText,
  isOptional = false,
  ...rest
}) {
  return (
    <Field name={name}>
      {({ field, meta }) => {
        const isInvalid = meta.touched && meta.error;
        return (
          <FormControl isInvalid={isInvalid} isRequired={!isOptional}>
            {label && (
              <FormLabel htmlFor={name} requiredIndicator={false}>
                {label}
              </FormLabel>
            )}
            <Select
              {...field}
              {...rest}
              id={name}
              data-testid={`select-${name}`}
              onChange={(e) => {
                rest && rest.onChange && rest.onChange(e);
                field && field.onChange && field.onChange(e);
              }}
            >
              {options.map(({ label, value }) => (
                <option value={value} key={`${name}-option-${value}`}>
                  {label}
                </option>
              ))}
            </Select>
            {!isInvalid && !!helperText ? (
              <FormHelperText>{helperText}</FormHelperText>
            ) : (
              <FormErrorMessage>{meta.error}</FormErrorMessage>
            )}
          </FormControl>
        );
      }}
    </Field>
  );
}

export default memo(SelectField);
